import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import themeable from 'zignal-landscape/lib/themeable';

const SidebarItem = ({
  styles,
  activeIndex = 0,
  index = 0,
  children,
  onClick = noop
}) => {
  const itemClassNames = {
    [styles.SidebarItem]: true,
    [styles.active]: index === activeIndex
  };

  return (
    <div
      data-cy={`sidebar-item-${index}`}
      className={classnames(itemClassNames)}
      onClick={onClick}
    >
      <span>{children}</span>
    </div>
  );
};

SidebarItem.propTypes = {
  styles: PropTypes.object.isRequired,
  activeIndex: PropTypes.number,
  index: PropTypes.number,
  children: PropTypes.node,
  onClick: PropTypes.func
};

export default themeable(SidebarItem);
